import { DateRangeQueryParams } from '@sonar-software/sonar-ts-types';

import { ApplicationAccessStatistic, EntityAccessStatistic, FieldAccessStatistic } from '@types';
import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';

export type GetDataSecurityAccessStatisticsRequest = DateRangeQueryParams & {
	applicationId?: number;
	stakeholderGroupId?: number;
};

export type GetDataSecurityAccessStatisticsResponse = {
	applications?: ApplicationAccessStatistic[];
	entities: EntityAccessStatistic[];
	fields: FieldAccessStatistic[];
};

export const getDataSecurityAccessStatistics = createGetEndpoint<
	GetDataSecurityAccessStatisticsRequest | undefined,
	GetDataSecurityAccessStatisticsResponse
>((request) => `/api/v3/data-security/organization/access-statistics?${getQueryString(request)}`);
